<div *ngIf="student" class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div class="bg-grey-lighter-color w-100 mb-3 p-2">
        <span class="fs-5 fw-bolder">Datos del colegio</span>
    </div>

    <!-- Colegio -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Colegio</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.school" readonly="true"/>
    </div>

    <!-- Localidad -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Localidad</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.location" readonly="true"/>
    </div>

    <!-- Provincia -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Provincia</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.province" readonly="true"/>
    </div>

    <!-- Código postal -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Código postal</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.postalCode" readonly="true"/>
    </div>

</div>
